import { useAppSelector } from "integrations/redux/hooks"
import store from "integrations/redux/store"
import { useEffect, type JSX } from "react"
import { isNonEmptyString } from "tools/strings/isNonEmptyString"
import { getPasswordPolicy } from "user/authentication/thunks"
import { selectClientApplicationId } from "./selectors"
import { initializeClientApplication } from "./thunks"

type SystemsManagerProps = {
    children?: JSX.Element | null
}

export default function SystemsManager({ children = null }: SystemsManagerProps) {
    const hasValidClientConfiguration = isNonEmptyString(useAppSelector(selectClientApplicationId))

    // simply runs a polled query. relevant slices are setup to listen to results -- search for 'listSystemsRequestFulfilled' to see how that works
    // note: this is currently not that relevant, as the processing control button will directly send a request as well
    // in the future, however, this will be what can give us a "live" state view of our application backbones, so leaving it for now as show-and-tell example

    useEffect(() => {
        store.dispatch(initializeClientApplication())
        store.dispatch(getPasswordPolicy())
    }, [])

    if (hasValidClientConfiguration) {
        return children
    }

    // @todo -- a nice spinner animation would be preferred while we wait for that initial request
    return null
}
